import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Shield, Heart, Users, Lock } from "lucide-react";
import { Link } from "react-router-dom";

interface PrivacyBannerProps {
  className?: string;
}

export function PrivacyBanner({ className }: PrivacyBannerProps) {
  return (
    <Card className={`p-4 bg-gradient-to-r from-teen-green-bright/30 to-teen-blue-bright/30 border-teen-green/30 ${className}`}>
      <div className="text-center space-y-3">
        {/* Privacy Promise */}
        <div className="flex items-center justify-center gap-2 mb-2">
          <Shield className="w-5 h-5 text-teen-green" />
          <h3 className="font-bold text-foreground">Our Privacy Promise</h3>
          <Shield className="w-5 h-5 text-teen-green" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-card/60">
            <Lock className="w-6 h-6 text-teen-blue" />
            <div className="text-center">
              <div className="font-semibold text-foreground">We Never Sell Your Data</div>
              <div className="text-xs text-muted-foreground">Your privacy is our top priority</div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-card/60">
            <Users className="w-6 h-6 text-teen-purple" />
            <div className="text-center">
              <div className="font-semibold text-foreground">Parent-Approved Safety</div>
              <div className="text-xs text-muted-foreground">Designed with young players in mind</div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-2 p-3 rounded-lg bg-card/60">
            <Heart className="w-6 h-6 text-teen-pink" />
            <div className="text-center">
              <div className="font-semibold text-foreground">Ad-Free Learning</div>
              <div className="text-xs text-muted-foreground">Focus on chess, not distractions</div>
            </div>
          </div>
        </div>

        {/* Privacy Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-4">
          <Badge variant="teen-green" className="text-xs">
            COPPA Compliant
          </Badge>
          <Badge variant="teen-blue" className="text-xs">
            GDPR Protected
          </Badge>
          <Badge variant="teen-purple" className="text-xs">
            Data Minimization
          </Badge>
        </div>

        {/* Learn More Link */}
        <p className="text-xs text-muted-foreground mt-3">
          Want to know more? Read our{" "}
          <Link 
            to="/privacy-policy" 
            className="text-teen-blue hover:text-teen-purple font-medium underline"
          >
            simple privacy policy
          </Link>{" "}
          written for teens and parents.
        </p>
      </div>
    </Card>
  );
}